module.exports = __webpack_public_path__ + "static/media/JacksonBldgAshevilleNC2006PencilandWatercoloronillustrationboard.5f939fdf.webp";